module.exports = __webpack_public_path__ + "54fc4cc1cae458ebbd55926ccdf6e512.pdf";